"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useIsSmartContractWallet } from "../../flow/hooks/useIsSmartContractWallet";
import { useChainIdentifier } from "../../polychain/hooks";
export const useSmartContractWalletWarningModal = t0 => {
  const $ = _c(6);
  const {
    destinationChain
  } = t0;
  const isSmartContractWallet = useIsSmartContractWallet();
  const activeChain = useChainIdentifier();
  const isCrossChain = activeChain !== destinationChain;
  const [smartContractWalletWarningModalOpen, setSmartContractWalletWarningModalOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isCrossChain || $[1] !== isSmartContractWallet) {
    t1 = () => {
      if (isSmartContractWallet && isCrossChain) {
        setSmartContractWalletWarningModalOpen(true);
      }
    };
    t2 = [isSmartContractWallet, isCrossChain];
    $[0] = isCrossChain;
    $[1] = isSmartContractWallet;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== smartContractWalletWarningModalOpen) {
    t3 = {
      smartContractWalletWarningModalOpen,
      setSmartContractWalletWarningModalOpen
    };
    $[4] = smartContractWalletWarningModalOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};